import { Help } from "@mui/icons-material";
import Translate from "../../utils/Translate";
import { Button } from "@mui/material";

export default function ActorPermitFlowDialogHeader({ title }) {
  return (
    <div className="stdFlexBetween">
      <div>{title ?? Translate.get("CreateActorPermit")}</div>

      <Button
        variant="text"
        startIcon={<Help />}
        onClick={() => {
          window.global.helpLink = { cat: "/dashboard/permits", subCat: "permits_checklist" };
          window.globalTriggerClick("helpTrigger");
        }}
      >
        {Translate.get("Checklist")}
      </Button>
    </div>
  );
}
